const ip = "https://pokeleaders.com";

export const ASSETS_URL = `https://pokeleaders.com/server-assets`;
export const BASE_URL = `${ip}/api`;

export const USER_URL = "/users";
export const PRODUCT_URL = "/products";
export const MEDAL_URL = "/medals";
export const USER_MEDALS_URL = "/usermedals";
export const CATEGORY_URL = "/categories";
export const AUTH_URL = "/auth";
export const CART_URL = "/cart";
export const TEAM_URL = "/teams";
export const POKEMONGO_URL = "/pokemongo";
export const ADMIN_URL = "/admin";
export const COUNTRY_URL = "/countries";
export const LEADERBOARD_URL = "/leaderboard";
export const UPLOAD_URL = "/images";
export const COMMUNITY_URL = "/communities";
